<div [style]="dynamicMarkStyle" [ngStyle]="getContainerStyle(reportMeasurementPoint)" (click)="onClick($event)">
  <div
    style="height: 9mm; padding: 0 5mm; font-weight: bold"
    [style.font-size]="reportMeasurementPoint.titleFontSize"
    [style.text-align]="reportMeasurementPoint.titleAlign"
    [style.background-color]="reportMeasurementPoint.titleBackgroundColor"
  >
    {{ reportMeasurementPoint.titleText }}
  </div>
  <div>
    <span>**Configure table for measurement results**</span>
  </div>
  <div [ngStyle]="getStyles(reportMeasurementPoint)" style="position: absolute">
    <table width="100%" rules="{{ reportMeasurementPoint.tableRules }}">
      <thead>
        <tr>
          <th *ngFor="let column of reportMeasurementPoint.columns" [style.padding]="reportMeasurementPoint.cellMargin + 'mm'">{{ column.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td *ngFor="let column of reportMeasurementPoint.columns" [style.padding]="reportMeasurementPoint.cellMargin + 'mm'">
            <span *ngIf="column.type === 'Dynamic'">{{ "[ " + column.dataField + " ]" || "--" }}</span>
            <span *ngIf="column.type === 'Editable'">[Editable Text]</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
